export const APP_CONFIG = {
  local: [
    {
      WEB_URL: "localhost",
      API_BASE_URL: `https://api-dev.agencytext.com`,
    },
    {
      WEB_URL: "app-local.agencytext.com",
      API_BASE_URL: `http://api-local.agencytext.com:8080`,
    },
    {
      WEB_URL: "app-local.textpickle.com",
      API_BASE_URL: `http://api-local.textpickle.com:8080`,
    },
    {
      WEB_URL: "app-local.clubtext.app",
      API_BASE_URL: `http://api-local.clubtext.app:8080`,
    },
    {
      WEB_URL: "app-local.bhisoftware.com",
      API_BASE_URL: `http://api-local.bhisoftware.com:8080`,
    },
  ],
  dev: [
    {
      WEB_URL: "app-dev.agencytext.com",
      API_BASE_URL: `https://api-dev.agencytext.com`,
    },
    {
      WEB_URL: "app-dev.textpickle.com",
      API_BASE_URL: `https://api-dev.textpickle.com`,
    },
    {
      WEB_URL: "app-dev.clubtext.app",
      API_BASE_URL: `https://api-dev.clubtext.app`,
    },
    {
      WEB_URL: "app-dev.associationtext.com",
      API_BASE_URL: `https://api-dev.associationtext.com`,
    },
    {
      WEB_URL: "app-dev.chambertext.com",
      API_BASE_URL: `https://api-dev.chambertext.com`,
    },
    {
      WEB_URL: "app-dev.5708sms.com",
      API_BASE_URL: `https://api-dev.5708sms.com`,
    },
    {
      WEB_URL: "app-dev.bhisoftware.com",
      API_BASE_URL: `https://api-dev.bhisoftware.com`,
    },
    {
      WEB_URL: "app-dev.padeltext.com",
      API_BASE_URL: `https://api-dev.padeltext.com`,
    },
    {
      WEB_URL: "app-dev.customertext.com",
      API_BASE_URL: `https://api-dev.customertext.com`,
    },
    {
      WEB_URL: "app-dev.clinictext.com",
      API_BASE_URL: `https://api-dev.clinictext.com`,
    },
  ],
  qa: [
    {
      WEB_URL: "app-qa.agencytext.com",
      API_BASE_URL: `https://api-qa.agencytext.com`,
    },
    {
      WEB_URL: "app-qa.textpickle.com",
      API_BASE_URL: `https://api-qa.textpickle.com`,
    },
    {
      WEB_URL: "app-qa.clubtext.app",
      API_BASE_URL: `https://api-qa.clubtext.app`,
    },
    {
      WEB_URL: "app-qa.associationtext.com",
      API_BASE_URL: `https://api-qa.associationtext.com`,
    },
    {
      WEB_URL: "app-qa.chambertext.com",
      API_BASE_URL: `https://api-qa.chambertext.com`,
    },
    {
      WEB_URL: "app-qa.5708sms.com",
      API_BASE_URL: `https://api-qa.5708sms.com`,
    },
    {
      WEB_URL: "app-qa.bhisoftware.com",
      API_BASE_URL: `https://api-qa.bhisoftware.com`,
    },
    {
      WEB_URL: "app-qa.padeltext.com",
      API_BASE_URL: `https://api-qa.padeltext.com`,
    },
    {
      WEB_URL: "app-qa.customertext.com",
      API_BASE_URL: `https://api-qa.customertext.com`,
    },
    {
      WEB_URL: "app-qa.clinictext.com",
      API_BASE_URL: `https://api-qa.clinictext.com`,
    },
  ],
  app: [
    {
      WEB_URL: "app.agencytext.com",
      API_BASE_URL: `https://api.agencytext.com`,
    },
    {
      WEB_URL: "app.textpickle.com",
      API_BASE_URL: `https://api.textpickle.com`,
    },
    {
      WEB_URL: "app.clubtext.app",
      API_BASE_URL: `https://api.clubtext.app`,
    },
    {
      WEB_URL: "app.associationtext.com",
      API_BASE_URL: `https://api.associationtext.com`,
    },
    {
      WEB_URL: "app.chambertext.com",
      API_BASE_URL: `https://api.chambertext.com`,
    },
    {
      WEB_URL: "app.5708sms.com",
      API_BASE_URL: `https://api.5708sms.com`,
    },
    {
      WEB_URL: "app.bhisoftware.com",
      API_BASE_URL: `https://api.bhisoftware.com`,
    },
    {
      WEB_URL: "app.padeltext.com",
      API_BASE_URL: `https://api.padeltext.com`,
    },
    {
      WEB_URL: "app.customertext.com",
      API_BASE_URL: `https://api.customertext.com`,
    },
    {
      WEB_URL: "app.clinictext.com",
      API_BASE_URL: `https://api.clinictext.com`,
    },
  ],
};
